import { render, staticRenderFns } from "./EditSharesLegacy.vue?vue&type=template&id=7bc1d751&"
import script from "./EditSharesLegacy.vue?vue&type=script&lang=ts&"
export * from "./EditSharesLegacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports